define( function() {
	return [ "Top", "Right", "Bottom", "Left" ];
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/css/var/cssExpand.js
// module id = 112
// module chunks = 0